const splitString = (str) =>
  str.split('').reduce((accum, thing, index) => {
    const iteration = Math.floor(index / 3)
    const mod = index % 3
    if (mod === 0) {
      accum.push(thing)
    } else {
      accum[iteration] = accum[iteration] + thing
    }
    return accum
  }, [])

const addCommas = (str) => {
  const len = str.length
  const mod = len % 3
  let result
  if (mod) {
    const beginning = [str.slice(0, mod)]
    const end = splitString(str.slice(mod))
    result = beginning.concat(end)
  } else {
    result = splitString(str)
  }
  return result.join(',')
}

export default (amount, includeCents = true) => {
  const isNegative = amount < 0 ? '-' : ''
  const value = Math.abs(amount)
  const str = value ? value.toString() : ''
  let dollars = str.slice(0, -2)
  let cents = str.slice(-2) || '00'
  if (cents.length !== 2) {
    cents = `0${cents}`
  }
  if (!dollars) {
    dollars = '0'
  }
  let result = `$${addCommas(dollars)}`
  result = includeCents ? `${result}.${cents}` : result
  return isNegative ? `(${result})` : result
}
